import * as React from "react"
import { SVGProps } from "react"
const OnlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#3DBE02"
      stroke="#3DBE02"
      strokeWidth={0.4}
      d="M1.635 7.778v-.002c4.193.699 7.465 4.147 7.989 8.338h-.001a.472.472 0 0 1-.454.566h-.042a.539.539 0 0 1-.339-.107.43.43 0 0 1-.16-.323C8.128 12.487 5.2 9.395 1.485 8.769h-.007l-.008-.003a.589.589 0 0 1-.315-.19.442.442 0 0 1-.088-.395.59.59 0 0 1 .19-.314.44.44 0 0 1 .379-.09Zm.06 3.891.01.003a5.938 5.938 0 0 1 4.068 4.335h-.002c.07.244-.09.515-.358.582l-.023.006h-.11a.522.522 0 0 1-.49-.35l-.004-.016c-.411-1.687-1.687-3.083-3.368-3.575v-.001c-.289-.077-.416-.366-.352-.624a.499.499 0 0 1 .53-.375l.098.015Z"
    />
    <path
      fill="#3DBE02"
      stroke="#3DBE02"
      strokeWidth={0.4}
      d="M1.615 4.226h.012c6.078.739 10.896 5.73 11.46 11.765a.471.471 0 0 1-.455.561h-.043a.537.537 0 0 1-.339-.107.431.431 0 0 1-.159-.332C11.586 10.48 7.128 5.896 1.493 5.223l-.011-.002-.013-.003a.527.527 0 0 1-.306-.2.566.566 0 0 1-.102-.336V4.65l.01-.032a.572.572 0 0 1 .532-.392h.012Zm14.822-2.918c.135 0 .258.059.354.155l.015.014.01.016c.07.104.098.23.098.341a.48.48 0 0 1-.123.34L12.303 6.66a.527.527 0 0 1-.356.145.525.525 0 0 1-.354-.145L8.986 4.054a.503.503 0 0 1-.156-.356c0-.134.06-.258.156-.354a.502.502 0 0 1 .354-.155c.135 0 .26.059.356.155l2.252 2.252 4.133-4.133a.503.503 0 0 1 .356-.155Z"
    />
  </svg>
)
export default OnlineIcon;
